import Vue from 'vue'
import App from "./App.vue"
import Login from './components/user-pages/Login'
import Home from './components/Home'
import Documentation from './components/Documentation'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import VueGtag from "vue-gtag";
import store from './store'
import {ALL_COMMANDS} from './commands/CommandExports'
import Commands from "./components/Commands";
import Servers from "./components/Servers";
import Policy from "./components/Policy";
import Contact from "./components/Contact";
import WebhooksLanding from "./components/user-pages/WebhooksLanding";
import RegistrationLanding from "./components/user-pages/RegistrationLanding";
import VueBraintree from 'vue-braintree'
import UserPayment from "./components/user-pages/UserPayment";
import PaymentWebhooks from "./components/user-pages/PaymentWebhooks";
import StreamingDarkPool from "./components/user-pages/DashboardDarkPool";
import StockExpanded from "./components/user-pages/stock-expanded/StockExpanded/StockExpanded";
import StreamingFlow from "./components/user-pages/DashboardFlow";
import StreamingCrypto from "./components/user-pages/DashboardCrypto";
import DashboardShort from "./components/user-pages/DashboardShort";
import DashboardStock from "./components/user-pages/DashboardStock";
import Dash from "./components/user-pages/DashboardMain";
import LandingPage from "./components/LandingPage";
import UserPaymentReSub from "./components/user-pages/UserPaymentReSub";
import PaymentReSubServer from "./components/user-pages/ServerPaymentReSub";
import UserPaymentUpgradeSub from "./components/user-pages/UserPaymentUpgradeSub";
import UserSettings from "./components/user-pages/UserSettings";
import VueSimpleAlert from "vue-simple-alert";
import { firestorePlugin } from 'vuefire'
import {checkCookie, COOKIE_USER_ID, COOKIE_USER_AUTH} from "@/utils/CookieHelper";
import SectorFlow from "./components/user-pages/stock-expanded/Sector/SectorFlow";
import HighchartsVue from 'highcharts-vue'
import darkUnica from "highcharts/themes/high-contrast-dark";
import Highcharts from "highcharts";
import Earnings from "./components/user-pages/Earnings";
import SectorRollup from "./components/user-pages/SectorRollup";
import mapInit from 'highcharts/modules/map'
import Treemap from 'highcharts/modules/treemap'

import moment from 'moment'

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
})

Highcharts.setOptions({
    credits: {
        enabled: false
    },
    lang: {
        numericSymbols: ['K', ' M', 'B', 'T']
    }})


Treemap(Highcharts)
mapInit(Highcharts)
darkUnica(Highcharts);
Vue.use(HighchartsVue)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueBraintree)
Vue.use(firestorePlugin)
Vue.use(VueSimpleAlert)

function createRoutes() {

    // Add any static routes to this literal
    let generatedRoutes = [
        { name: "Login", path: '/login', component: Login },
        { name: "Settings", path: '/settings', component: UserSettings },
        { name: "Webhooks", path: '/Webhooks', component: WebhooksLanding },
        { name: "Registration", path: '/registration', component: RegistrationLanding },
        { name: "Payment", path: '/payment', component: UserPayment },
        { name: "PaymentReSub", path: '/paymentresub', component: UserPaymentReSub },
        { name: "PaymentReSubServer", path: '/paymentserver', component: PaymentReSubServer },
        { name: "PaymentWebhooks", path: '/paymentwebhooks', component: PaymentWebhooks },
        { name: "PaymentUpgradeSub", path: '/paymentupgradesub', component: UserPaymentUpgradeSub },
        { name: "DashboardShort", meta: {requiresAuth: true}, path: '/shorts', component: DashboardShort },
        { name: "DashboardStock", path: '/insights', component: DashboardStock },
        { name: "DarkPoolFlow", meta: {requiresAuth: true}, path: '/darkpool', component: StreamingDarkPool },
        { name: "OptionsFlow", meta: {requiresAuth: true}, path: '/options', component: StreamingFlow },
        { name: "CryptoFlow", meta: {requiresAuth: true}, path: '/crypto', component: StreamingCrypto },
        { name: "Expanded", meta: {requiresAuth: true}, path: '/expanded', component: StockExpanded },
        { name: "SectorFlow", meta: {requiresAuth: true}, path: '/sectorflow', component: SectorFlow },
        { name: "Earnings", path: '/earnings', component: Earnings, props: (route) => ({
                timePeriod: route.query.timePeriod,
            }) },
        { name: "SectorRollup", meta: {requiresAuth: true},path: '/sectors', component: SectorRollup, props: (route) => ({
                sectorMap: route.query.sectorMap,
            }) },
        { name: "DashMain", path: '/dashboard', component: Dash },
        { name: "LandingMain", path: '/flowbyofb', component: LandingPage },
        { name: "Home", path: '/', component: Home },
        { name: "Servers", path: '/servers', component: Servers },
        { name: "Commands", path: '/documentation', component: Commands },
        { name: "Policy", path: '/policy', component: Policy },
        { name: "Contact", path: '/contact', component: Contact }
    ]

    for (let commandPackage of ALL_COMMANDS){
        let cleanNavTitle = commandPackage.navTitle.replace(" ", "")

        // General route, i.e /documentation/stocks
        generatedRoutes.push({
            name: cleanNavTitle,
            path: `/documentation/${cleanNavTitle}`,
            component: Documentation,
            params: {
                topic: cleanNavTitle,
                goToReference: null
            }
        })

        // Sub-route, i.e /documentation/stocks/price
        generatedRoutes.push({
            name: commandPackage.routerName,
            path: `/documentation/${cleanNavTitle}/:goToReference`,
            component: Documentation,
            props: true
        })
    }

    return generatedRoutes;
}

const routes = createRoutes()

const router = new VueRouter({
    routes,
    mode: 'history'
})

Vue.use(VueGtag, {
    config: { id: "UA-69872206-3" }
}, router);


// Prevent user from going anywhere but the login page if they are not logged in
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
    if (requiresAuth && (!checkCookie(COOKIE_USER_ID) || !checkCookie(COOKIE_USER_AUTH))) {
        // for instance
        next({name: "Login"})
    } else {
        next()
    }
});

new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {App},
    vuetify,
    render: h => h(App)
})

